import { ToolStatus } from '../../types/tool.types';
export const SQL_TOOL_NAMES = [
    'list_tables',
    'describe_tables',
    'execute_sql',
];
export const ANALYZE_GRANT_CARD_STATUS_KEY = 'assistant.tool_analyze_grant_card';
export const WEB_SEARCH_CARD_STATUS_KEY = 'assistant.tool_web_search_card';
export const SEARCH_GRANTS_QUERYING_STATUS_KEY = 'assistant.tool_search_grants_querying';
export const getToolDisplayVariant = (toolName) => {
    if (SQL_TOOL_NAMES.includes(toolName)) {
        return 'sql';
    }
    switch (toolName) {
        case 'search_grants':
            return 'search_grants';
        case 'web_search':
            return 'web_search';
        case 'analyze_grant':
            return 'analyze_grant';
        default:
            return 'generic';
    }
};
export const getToolLabelKey = (toolName) => {
    const toolNameMap = {
        search_grants: 'assistant|tool_search_grants',
        web_search: 'assistant|tool_web_search',
        list_tables: 'assistant|tool_list_tables',
        describe_tables: 'assistant|tool_describe_tables',
        execute_sql: 'assistant|tool_execute_sql',
    };
    return toolNameMap[toolName] || `assistant|tool_${toolName}`;
};
export const isToolExpandable = (app, displayVariant) => app === 'admin' || displayVariant === 'analyze_grant';
export const getDefaultExpanded = (app, displayVariant) => app !== 'admin' && displayVariant === 'analyze_grant';
export const getDefaultExpandedSections = (status) => {
    switch (status) {
        case ToolStatus.FAILURE:
        case ToolStatus.SUCCESS:
        case ToolStatus.PARTIAL:
            return ['arguments', 'result'];
        case ToolStatus.PENDING:
        case ToolStatus.RUNNING:
        default:
            return ['arguments'];
    }
};
export const getToolStatusText = (status, translate, errorText) => {
    const translatedStatus = translate(`assistant|tool_status_${status}`, translate('assistant|tool_status_unknown', 'Unknown status'));
    if (status === ToolStatus.FAILURE && errorText) {
        return `${translatedStatus}: ${errorText}`;
    }
    return translatedStatus;
};
